// These polyfills make stable language features of modern ECMAScript
// available accross all target browsers. We include IE11 as it is
// currently still functionally supported for broader web projects
// such as www.ag.ch. Remove or limit these polyfills to reduce build
// if your project allows.
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// IE11 cannot forEach over nodelists
Array.prototype.forEach.call(document.querySelectorAll(`[data-${process.env.REACT_APP_NAME}]`), (element) => {
  ReactDOM.render(
    React.createElement(App, {
      standalone: element.dataset.standalone === 'true',
      apiUrl: element.dataset.api,
      translationApiUrl: element.dataset.translationApi,
      translationMissingApiUrl: element.dataset.translationMissingApi,
    }),
    element,
  );
});
